module.exports = __webpack_public_path__ + "img/project-17.dd9dea54.png";